import { render, staticRenderFns } from "./stack-trace.vue?vue&type=template&id=13afa780"
import script from "./stack-trace.vue?vue&type=script&lang=js"
export * from "./stack-trace.vue?vue&type=script&lang=js"
import style0 from "./stack-trace.vue?vue&type=style&index=0&id=13afa780&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports